import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { AdStatsBridgeAdUnitsService } from '../../../shared/services/ad-stats-bridge-ad-units.service';
import { User } from '../../../shared/domain/users/user.model';

@Component({
  selector: 'cm-team-support-dialog',
  template: `
    <div mat-dialog-title>
      <span>Team support</span>
    </div>
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 col-lg-6">
          <!--<div *ngFor="let email of predefinedEmails">-->
            <!--<mat-checkbox class="" (change)="selectEmail(email)">{{email}}</mat-checkbox>-->
          <!--</div>-->
          <div style="max-width: 300px">
            <cm-user-email-autocomplete-chips [filterRoles]="['CM_USER']" (userSelectionChange)="usersChange($event)"></cm-user-email-autocomplete-chips>

          </div>
        </div>
        <div class="col-12 col-lg-6">
          <mat-form-field floatLabel="always" class="w-100">
          <textarea matInput name="notes" required [(ngModel)]="notes" style="min-height: 250px "
                    placeholder="Comment" class="textarea-note"></textarea>
            <!--<mat-hint>*comma or new line separated list of domains</mat-hint>-->
          </mat-form-field>
        </div>
        <hr class="w-100">
        <div class="col-12 mt-3">
          <p><strong>Unit list</strong></p>
          <mat-list class="">
            <mat-list-item *ngFor="let unit of units">
              {{unit.name}}
              <mat-divider></mat-divider>
            </mat-list-item>
          </mat-list>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
      <button mat-raised-button class="iconed" color="primary"
              [disabled]="!selectedEmails.length"
              (click)="save()">
        <i class="fas fa-save"></i>
        <span>Send email</span>
      </button>
    </div>
  `,
  styles: [`
    .mat-row {
      border-bottom: none;
      min-height: 40px;
      height: 40px;
    }

    .mat-cell,
    .mat-header-cell {
      padding: 0 10px;
    }
  `]
})
export class TeamSupportDialogComponent {
  units: UnitShortModel[];
  notes: string;

  predefinedEmails = ['mark@consumable.com', 'jennifer@consumable.com', 'bogdan@consumable.com', 'naffis@consumable.com',
    'jeff@consumable.com', 'jestin@consumable.com', 'gordan@consumable.com', 'sloba@consumable.com'];
  selectedEmails = [];

  constructor(public dialogRef: MatDialogRef<TeamSupportDialogComponent>,
              private gss: GlobalSpinnerService,
              private service: AdStatsBridgeAdUnitsService,
              private sbs: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.units = data.units;
  }

  selectEmail(email) {
    email = email.trim();
    if (!this.selectedEmails.includes(email)) {
      this.selectedEmails.push(email);
    } else {
      this.selectedEmails = this.selectedEmails.filter(e => email !== e);
    }
  }

  save() {
    this.gss.showLoader();
    this.service.adUnitsTeamSupportEmail({
      emails: this.selectedEmails,
      comment: this.notes,
      adUnitIds: this.units.map(u => u.id)
    }).subscribe(next => {
      this.gss.hideLoader();
      this.dialogRef.close(true);
      this.sbs.success('Email sent successfully');
    }, () => {
      this.gss.hideLoader();
      this.sbs.success('Error occurred during email sending');
    });

  }

  usersChange(users: User[]) {
    const emails = users.map(u => u.email);
    this.selectedEmails = this.selectedEmails.filter(e => emails.includes(e));
    this.selectedEmails = this.selectedEmails.concat(emails.filter(e => !this.selectedEmails.includes(e)));
    // console.log(this.selectedEmails)
  }
}

export class UnitShortModel {
  id: string;
  name: string;
}
